import { branding } from 'branding';

export const Header = () => {
  return branding.header;
};
